import Echo from "laravel-echo";
import Pusher from "pusher-js";

window.Pusher = Pusher;

const PUSHER_APP_KEY = process.env.REACT_APP_PUSHER_KEY;
const PUSHER_APP_CLUSTER = process.env.REACT_APP_PUSHER_CLUSTER;

// Lazy singleton. Creating an Echo instance opens a Pusher WebSocket immediately,
// and every open connection counts against the Pusher plan's concurrent-connection
// quota. Building it on first use (instead of at module import) means only pages
// that actually listen for events (interpreter portal, active call pages) hold a
// connection — not every admin/client/login tab.
let echoInstance = null;

export const getEcho = () => {
  if (!echoInstance) {
    echoInstance = new Echo({
      broadcaster: "pusher",
      key: PUSHER_APP_KEY,
      cluster: PUSHER_APP_CLUSTER,
      forceTLS: true,
    });
  }
  return echoInstance;
};

// Close the socket and drop the cached instance (used on logout).
export const disconnectEcho = () => {
  if (echoInstance) {
    try {
      echoInstance.disconnect();
    } catch (e) {
      // ignore — socket may already be closed
    }
    echoInstance = null;
  }
};

export default getEcho;
